/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const exportTimesheetEntriesQueryParamsSchema = z.object({
  focusDate: z.string().date(),
  mockUser: z.coerce.number().int().optional(),
});

/**
 * @description OK
 */
export const exportTimesheetEntries200Schema = z.any();

export const exportTimesheetEntriesQueryResponseSchema = z.lazy(
  () => exportTimesheetEntries200Schema,
);
